import {
  Contact,
  EmailContact,
  RentalDocumentSendout,
  RentalDocumentType,
  ReturnalDocumentSendout,
  ReturnalDocumentType
} from '../api/dtos/dtos';
import * as React from 'react';
import {Button, Table, Tag} from 'antd';
import locales from "../locales";
import SectionHeaderFormItem from "../common/form-items/SectionHeaderFormItem";
import FormItem from "antd/lib/form/FormItem";
import * as formUtils from "../utils/form-utils";
import {LoadingOverlayHandler,} from "../app/ApplicationContext";
import {ColumnProps} from "antd/lib/table";
import {indexRowKeyFn, simpleColumn} from "../utils/table-utils";
import {formatDateTime} from "../utils/date-utils";
import {documentTypeToText} from "./dtos";
import EmailContactTag from "../common/EmailContactTag";

interface Props {
  documents: Array<RentalDocumentSendout | ReturnalDocumentSendout>;
  onSendoutDocument: () => void;
  style?: React.CSSProperties;
  rentalDeleted?: boolean;
}

interface State {
  recipientContacts: Contact[];
}


class DocumentSendoutSummaryComponent extends React.Component<Props, State> {
  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: Props) {
    super(props);
    this.state = {
      recipientContacts: [],
    }
  }

  public shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
    return nextProps !== this.props;
  }


  public render(): React.ReactNode {
    const {documents} = this.props;

    const columns: Array<ColumnProps<RentalDocumentSendout>> = [
      {
        ...simpleColumn(locales.document_send_out, r => formatDateTime(r.sendoutAt!)),
        width: 150,
      },
      {
        ...simpleColumn(locales.document_sendout_documents, r => this.renderDocumentTypeTags(r.documentTypes)),
        width: '30%'
      },
      {
        ...simpleColumn(locales.document_recipients, r => this.renderRecipientTags(r.recipients)),
        width: '70%',
      }
    ];

    return (
      <>
        <SectionHeaderFormItem title={locales.document_sendout_documents} style={{marginTop: 48}} />
        <Table
          style={{marginBottom: 24}}
          columns={columns}
          dataSource={documents}
          rowKey={indexRowKeyFn}
          bordered={true}
          pagination={false}
          size="small"
          scroll={{x: 1024}}
          locale={{emptyText: locales.document_no_sendouts}}
        />
        <FormItem {...formUtils.tailFormItemLayout}>
          <Button
            type={"primary"}
            disabled={this.props.rentalDeleted}
            onClick={this.props.onSendoutDocument}
          >
            {locales.document_send}
          </Button>
        </FormItem>
      </>
    );

  }

  private renderRecipientTags(recipients: EmailContact[]) {
    return (
      <div style={{lineHeight: 2}}>
        {recipients.map((c) => <EmailContactTag key={c.id} contact={c}/>)}
      </div>
    );
  }

  private renderDocumentTypeTags(types: Array<RentalDocumentType | ReturnalDocumentType>) {
    return (
      <>
        {types.map((t) =>
          <Tag key={String(t)} style={{marginTop: 4, marginBottom: 4}} title={t}>{documentTypeToText[t]}</Tag>
        )}
      </>
    );
  }

}

export default DocumentSendoutSummaryComponent;



// WEBPACK FOOTER //
// ./src/document-sendout/DocumentSendoutSummaryComponent.tsx